exports.components = {
  "component---src-core-pages-page-template-tsx": () => import("./../../../src/core/pages/PageTemplate.tsx" /* webpackChunkName: "component---src-core-pages-page-template-tsx" */)
}

